import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ListItemText, createTheme } from "@mui/material";
import { styled as muiStyled } from "@mui/system";
import { globalColors } from "../../../Utils/colors";

const ITEM_HEIGHT = 46;
const ITEM_PADDING_TOP = 8;
const PAPER_WIDTH = 225;

export const getDropDownTheme = (fullWidth: boolean | undefined) => {
  return createTheme({
    components: {
      MuiFormControl: {
        styleOverrides: {
          root: {
            backgroundColor: globalColors.white,
            width: fullWidth ? "100%" : PAPER_WIDTH,
          },
        },
      },
      MuiInputAdornment: {
        styleOverrides: {
          root: {
            color: globalColors.primary,
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          root: {
            color: globalColors.primary,
            fontFamily: "Poppins",
            fontSize: "12px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "93%",
            flexGrow: "inherit",
          },
        },
      },
    },
  });
};

export const getDropDownMenuProps = () => {
  return {
    PaperProps: {
      style: {
        marginTop: 3,
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: PAPER_WIDTH,
      },
    },
  };
};

export const StyledMenuItem = muiStyled(MenuItem, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected: boolean }>(({ isSelected }) => ({
  padding: "4px",
  width: "100%",
  backgroundColor: globalColors.white,
  "&:hover": {
    backgroundColor: globalColors.lightHoverColor,
  },
}));

export const StyledDropDownMenuItem = muiStyled(MenuItem, {
  shouldForwardProp: (prop) => prop !== "isMulti",
})<{ isMulti: boolean }>(({ isMulti }) => ({
  padding: isMulti ? "0px" : "7px",
  backgroundColor: globalColors.white,
  "&:hover": {
    backgroundColor: globalColors.white,
  },
}));

export const StyledListItemIcon = muiStyled(ListItemIcon)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const StyledListItemText = muiStyled(ListItemText)<{}>(() => ({
  paddingRight: "8px",
}));
